module.exports = __webpack_public_path__ + "img/cardFrame_S_4.94ff815a.png";